export const REQUEST_MAINTENANCE_FIELDS = {
  subject: {
    name: 'subject',
    id: 'request-maintenance-subject',
    label: 'checkIn:equipments.requestMaintenance.mailSubject',
    defaultValue: '',
  },
  body: {
    name: 'body',
    id: 'request-maintenance-body',
    label: 'checkIn:equipments.requestMaintenance.addMessage',
    defaultValue: '',
  },
}

export const REQUEST_MAINTENANCE_DEFAULT_VALUES = {
  [REQUEST_MAINTENANCE_FIELDS.subject.name]: REQUEST_MAINTENANCE_FIELDS.subject.defaultValue,
  [REQUEST_MAINTENANCE_FIELDS.body.name]: REQUEST_MAINTENANCE_FIELDS.body.defaultValue,
}
